<app-more-menu *ngIf="options?.visible" [items]="items"></app-more-menu>
